import type { RequiredBy } from '@repo/internal-tools-type-utils/src/utils.ts'
import type { components } from './generated/ccc-backend.types.ts'

export type ErrorResponseData = RequiredBy<
  components['schemas']['Earnin.Web.Server.ErrorResponse'],
  'code'
>

export class UnauthorizedError extends Error {
  constructor(message?: string | null) {
    super(message || 'Unauthorized')
  }
}

export class UserInfoAccessError extends Error {
  constructor(message?: string | null) {
    super(message || 'User info access error')
  }
}

export class ForbiddenError extends Error {
  constructor(message?: string | null) {
    super(message || 'Forbidden')
  }
}

export class NotFoundError extends Error {
  constructor(message?: string | null) {
    super(message || 'Not found')
  }
}

export class InternalServerError extends Error {
  constructor(message?: string | null) {
    super(message || 'Internal server error')
  }
}

export class FetchError extends Error {
  constructor(message?: string | null) {
    super(message || 'Failed to fetch data')
  }
}
